import { LinkButton } from '@/atoms/Button'
import { paths } from '@/constants'
import { useTranslate } from '@/utils/translate/translate-client'

const buttonClassNames =
  'w-full md:w-fit justify-center min-w-[121px] px-6 md:px-7 py-[14px] md:py-[17px] max-h-[56px] rounded-[14px]'

export const TorchSubmitButton = ({
  handleSubmitClicked,
  isDark = true,
}: {
  handleSubmitClicked: () => void
  isDark?: boolean
}) => {
  const { t } = useTranslate('create')

  return (
    <LinkButton
      href={paths.guild.create.torch}
      variant={isDark ? 'white' : 'core-gray-900'}
      className={buttonClassNames}
      onClick={handleSubmitClicked}
    >
      <div className="relative flex flex-row items-center justify-center gap-2">
        {t('submitProject', 'Submit Project')}
      </div>
    </LinkButton>
  )
}
